import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {isUndefined} from "util";
import {AttachmentView} from "../../+tickets/ticket.service";

@Pipe({
    name: 'filePipe'
})
export class FilePipe implements PipeTransform {

    constructor(private domSn: DomSanitizer) {
    }

    transform(attachment: AttachmentView): any {
        if (!isUndefined(attachment.contentType)) {
            if (attachment.contentType.indexOf('image') != -1) {
                let b64Img = `data:${attachment.contentType};base64,${attachment.fileB64Content}`;
                return this.domSn.bypassSecurityTrustResourceUrl(b64Img);
            } else {
                if (attachment.contentType.indexOf('pdf') != -1) {
                    return "assets/img/pdf.png";
                } else {
                    return "assets/img/file_icon.png"
                }
            }
        }
    }
}